<template>
  <div v-if="gameId">
    <info-tooltip
      title="Login to play"
      ref="tooltip"
      :visible-on-hover="true"
      :visible-on-load="false"
      :offset="50"
      @click.native.stop
      v-if="!hasPermission"
    >
      <p>In order to play this game, you need to be logged into an account.</p>
      <p>
        <router-link :to="{ name: 'Login' }" class="link--underlined">
          <span>Login</span>
        </router-link>
        or
        <a
          class="link--underlined"
          href="mailto:peter.nikashin@igt.com?subject=IGT Casino Lounge - Request Account"
        >Enquire about an account</a>
      </p>
    </info-tooltip>
    <div v-if="primaryCta">
      <theme-btn
        v-if="$mq === 'mob' || $mq === 'ptab'"
        class="btn--shape--h48--not-phab min-w--217--not-phab min-w--168--phab"
        :link="$root.getGameDemo(game)"
        target="_blank"
        @click="onClick($event, true)"
      >{{ ctaText }}</theme-btn>
      <theme-btn
        v-else
        class="btn--shape--h48--not-phab w--100p"
        @click="onClick"
      >{{ ctaText }}</theme-btn>
    </div>
    <div v-else>
      <mq-layout :mq="['mob', 'ptab']">
        <a
        	class="fonticon fonticon--plus--circle fs--40"
        	:href="$root.getGameDemo(game)"
        	target="_blank"
        	@click="onClick($event, true)"></a>
      </mq-layout>
      <mq-layout :mq="['ltab', 'desk']">
        <span class="link--action link--arrow" @click="onClick">{{ ctaText }}</span>
      </mq-layout>
    </div>
  </div>
</template>

<script>
import { find } from "lodash";

import Btn from "../atoms/Btn";
import ThemeBtn from "../atoms/ThemeBtn";
import InfoTooltip from "../molecules/InfoTooltip";

export default {
  components: {
    Btn,
    ThemeBtn,
    InfoTooltip
  },
  props: {
		text: {
			type: String,
			default: 'Play Game'
		},
    gameId: Number,
    primaryCta: Boolean
  },
  data() {
    return {
    };
  },
  computed: {
  	game() {
  		return this.gameId && this.$root.games ? find(this.$root.games, { id: this.gameId }) : null;
  	},
    ctaText() {
      return this.text || "Play Game";
    },
    hasPermission: function() {
      var self = this;
      return self.$root.userHasPermission({
        igt: ["AM", "CM", "SA"],
        operator: ["customer", "performance"]
      });
    }
  },
  methods: {
    onClick(evt, skipPopup) {
      var self = this;

      if(typeof skipPopup === 'undefined') { skipPopup = false; }

      if (!self.hasPermission) {
        evt.preventDefault();
        evt.stopPropagation();
        self.$refs.tooltip.isVisible = true;
        return;
      }

      if(!skipPopup)
      {
	      self.$root.$data.gameDemo = this.game;
	    }

      self.trackEvent([
        "hero-game-demo-clicked",
        self.game.gameName,
        self.$root.$data.user ? self.$root.$data.user.trackName : null,
        0,
        false
      ]);
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/organisms/PlayGameHeroButton.vue